import { GetServerSidePropsContext } from 'next';

import { deleteCookie, getCookie, setCookie } from '@/util/cookieUtil';
import { LWTDate } from '@/valueObjects/date';

// 1時間
const JWT_LIFE_TIME = 1;
export const JWT_KEY = 'lwtApiJwtConcierge';

export const deleteJwt = (context?: GetServerSidePropsContext) => {
  deleteCookie(JWT_KEY, context);
};

export const getJwt = (context?: GetServerSidePropsContext): string | undefined => {
  return getCookie(JWT_KEY, context);
};

export const setJwt = (jwt: string, context?: GetServerSidePropsContext) => {
  const expires = new LWTDate();
  expires.setHours(expires.getHours() + JWT_LIFE_TIME);
  setCookie(JWT_KEY, jwt, expires, context);
};
